// extracted by mini-css-extract-plugin
module.exports = {"dashboardAccessGraph":"chart_dashboardAccessGraph__1ksbM"};